import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { initialize } from '@americanexpress/script-supplier';
import { getEnvironmentSelector } from '@americanexpress/travel-selectors';

const useEnsighten = (locale) => {
  const environment = useSelector(getEnvironmentSelector);

  useEffect(() => {
    if (global.BROWSER) {
      window.euLocale = locale;
      window.scriptSupplierPageLocale = locale;
      const scripts = [
        {
          name: 'ensighten',
          version: '^1.0.0',
          async: true,
          config: {
            market: locale,
            source: 'OneAmex',
            businessUnit: 'Travel',
          },
        },
      ];
      initialize({
        scripts,
        scriptEnvironment: environment,
        pageLocale: locale,
      });
    }
  }, [locale, environment]);
};

export default useEnsighten;
